import styled from 'styled-components';

interface IconWrapperStyled {
  disabled?: boolean;
}

const IconWrapper = styled.div.withConfig({
  shouldForwardProp: prop => prop !== 'disabled',
})<IconWrapperStyled>`
  display: flex;
  border-radius: 6px;
  border: 1px solid #1777ff;
  opacity: ${props => props.disabled ? 0.5 : 1};
  padding: 7px;
`;

export default IconWrapper;
